export default [
  {
    title: 'Copper Weight',
    lines: [
      'Select the copper weight to accommodate the current requirements ' +
      'of your design. Most commercially available PCBs are manufactured ' +
      'for low-voltage/low power applications, with copper traces or planes ' +
      'made up of copper weights ranging from 1/2 oz/ft2 to 3 oz/ft2. A heavy ' +
      'copper circuit is manufactured with copper weights anywhere between 4 oz/ft2 to 20 oz/ft2.',
    ],
  },
  {
    title: 'Panelization',
    lines: [
      'You can upload your one up or stepped and repeated Gerber files... If your Gerber ' +
      'files are stepped and repeated your boards will be panelized accordingly. ' +
      'If the Gerber files are one up we will panelize the boards as described ' +
      'in the quote form. We recommend that you request a checkplot showing the ' +
      'panel configuration for your review and approval.',
    ],
  },
];
